import { render, staticRenderFns } from "./shareInviteMember.vue?vue&type=template&id=8050c844&scoped=true"
import script from "./shareInviteMember.vue?vue&type=script&lang=js"
export * from "./shareInviteMember.vue?vue&type=script&lang=js"
import style0 from "./shareInviteMember.vue?vue&type=style&index=0&id=8050c844&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8050c844",
  null
  
)

export default component.exports